import React from "react";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import AcxMicroPlayer from "components/UI/Audio/AcxMicroPlayer";

export default class AcxFormatters {
    playerFormatter: (params: GridRenderCellParams) => React.ReactNode = (
        params,
    ) => {
        const amdId = params.row?.audioMetadataId;
        if (!amdId) return <></>;

        return (
            <AcxMicroPlayer
                style={{ marginLeft: "auto", marginRight: "auto" }}
                downloadMediaFileId={amdId}
                mediaSourceType="audioFile"
            />
        );
    };
}
